import { colors } from "./colors";

export const platforms = [
	{
		id: "iphone",
		title: "iPhone",
		body: "Daily tracking, widgets, and the assistant in your pocket."
	},
	{ id: "ipad", title: "iPad", body: "More room for wishboxes, reports, and planning." },
	{ id: "mac", title: "Mac", body: "A desktop view for deeper review and clean money admin." },
	{
		id: "watch",
		title: "Apple Watch",
		body: "Deposits, voice, and a glance at what is left to save."
	},
	{ id: "android", title: "Android", body: "Coming soon. Phone and tablet get the same Wishbox." },
	{ id: "wear", title: "Wear OS", body: "Coming soon. The same wrist view as Apple Watch." }
];

export const proofItems = ["iPhone", "iPad", "Mac", "Apple Watch", "Android soon", "Wear OS soon"];

export const assistantPrompts = [
	"Add expense of 50 euros for groceries",
	"Import transactions from a bank export",
	"Check all transactions for duplicates",
	"Give me last 3 months insights",
	"Create an emergency fund Wishbox of 2000 to reach in one year",
	"Deposit all Wishbox item's remaining amount for this month"
];

export const plusFeatures = [
	{
		title: "Collaboration",
		description: "Share items with others and keep transactions in sync across devices.",
		image: "/assets/promo/plus_collaboration.png"
	},
	{
		title: "AI Assistant",
		description:
			"Chat with an assistant that helps add transactions, import bank files, and understand your finances.",
		image: "/assets/promo/plus_assistant.png"
	},
	{
		title: "Assistant widget",
		description:
			"Meet the Wishbox mascot, live in 3D on your widgets. Let it entertain you, or tap it to chat with the assistant.",
		image: "/assets/mascot/Pose_SitThink.png"
	},
	{
		title: "Multiple currencies",
		description: "Add transactions in different currencies and convert them on your month balance."
	},
	{
		title: "Budgets",
		description: "Set spend limits per category and track remaining budget through each cycle."
	},
	{
		title: "Deposit and Keep Up widgets",
		description:
			"Deposit to wishbox items in a tap, and keep income and expenses in sync when transactions go missing.",
		image: "/assets/promo/plus_widgets_tools.png"
	},
	{
		title: "Better info widgets",
		description: "Get a clearer look at net worth, spending, and the month from your home screen.",
		image: "/assets/promo/plus_widgets_info.png"
	},
	{
		title: "Brick Puzzle",
		description:
			"Turn a closed month of spending, or a budget, into a puzzle and beat your best time."
	},
	{
		title: "Cloud Sync",
		description: "Keep your full app database in your own iCloud or Google Drive."
	},
	{
		title: "Export",
		description: "Export transactions to CSV."
	},
	{
		title: "Backup & Restore",
		description: "Backup, share, and restore your entire app state."
	}
];

export const colorCycle = [
	colors.blue,
	colors.teal,
	colors.magenta,
	colors.orange,
	colors.yellow,
	colors.purple
];
